import { enIN } from './en_in';

const loaders = {
  HI_IN: () => import('./hi_in').then((m) => m.hiIN),
  BN_IN: () => import('./bn_in').then((m) => m.bnIN),
  TA_IN: () => import('./ta_in').then((m) => m.taIN),
  TE_IN: () => import('./te_in').then((m) => m.teIN),
  MR_IN: () => import('./mr_in').then((m) => m.mrIN),
  GU_IN: () => import('./gu_in').then((m) => m.guIN),
  KN_IN: () => import('./kn_in').then((m) => m.knIN),
  ML_IN: () => import('./ml_in').then((m) => m.mlIN),
  OD_IN: () => import('./od_in').then((m) => m.odIN),
  PA_IN: () => import('./pa_in').then((m) => m.paIN),
  AS_IN: () => import('./as_in').then((m) => m.asIN),
  UR_IN: () => import('./ur_in').then((m) => m.urIN),
  NE_IN: () => import('./ne_in').then((m) => m.neIN),
  SD_IN: () => import('./sd_in').then((m) => m.sdIN),
  KS_IN: () => import('./ks_in').then((m) => m.ksIN),
  SA_IN: () => import('./sa_in').then((m) => m.saIN),
  KOK_IN: () => import('./kok_in').then((m) => m.kokIN),
  DOI_IN: () => import('./doi_in').then((m) => m.doiIN),
  MAI_IN: () => import('./mai_in').then((m) => m.maiIN),
  BRX_IN: () => import('./brx_in').then((m) => m.brxIN),
  SAT_IN: () => import('./sat_in').then((m) => m.satIN),
  MNI_IN: () => import('./mni_in').then((m) => m.mniIN),
};

const cache = { EN_IN: enIN };

export const SupportedLocales = ['EN_IN', ...Object.keys(loaders)];

export const isLocaleLoaded = (locale) => Boolean(cache[locale]);

export const loadLocale = async (locale) => {
  if (cache[locale]) return cache[locale];
  const loader = loaders[locale];
  if (!loader) return enIN;
  try {
    cache[locale] = await loader();
    return cache[locale];
  } catch {
    return enIN;
  }
};

export const getLocaleLabels = (locale) => cache[locale] || enIN;

export { enIN };
